<template>
  <b-card
    no-body
    class="card-employee-task"
  >
    <b-card-header>
      <b-card-title class="text-uppercase">
        <h1>
          <strong>
            <FeatherIcon
              icon="MapIcon"
              size="30"
            />
            Recipient Details
          </strong>
        </h1>
      </b-card-title>
    </b-card-header>

    <!-- body -->
    <b-card-body>
      <b-row>
        <b-col cols="12">
          <b-list-group flush>
            <b-list-group-item class="border-0 py-0">
              <h4>
                <strong>Recipient's Name:</strong>
              </h4>
              <h4 class="pb-1">
                <span class="d-block font-weight-normal">{{ order.client.name }}</span>
              </h4>
            </b-list-group-item>
            <b-list-group-item class="border-0 py-0">
              <h4>
                <strong>Recipient's Address:</strong>
              </h4>
              <h4 class="pb-1">
                <span class="d-block font-weight-normal">{{ order.recipient.complete }}</span>
              </h4>
            </b-list-group-item>
            <b-list-group-item class="border-0 py-0">
              <h4>
                <strong>Person In Charge:</strong>
              </h4>
              <h4 class="pb-1">
                <span class="d-block font-weight-normal">{{ order.recipient.name }}</span>
              </h4>
            </b-list-group-item>
            <b-list-group-item class="border-0 py-0">
              <h4>
                <strong>Phone Number:</strong>
              </h4>
              <h4>
                <span class="d-block font-weight-normal">{{ order.recipient.phone }}</span>
              </h4>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardTitle, BCardHeader, BCardBody,
} from 'bootstrap-vue'

export default {
  name: 'DeliveryDestination',
  components: {
    BCard,
    BCardTitle,
    BCardHeader,
    BCardBody,
  },
  props: {
    order: {
      required: true,
      type: [Array, Object],
    },
  },
}
</script>

<style>

</style>
